var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"nov-area",style:(_vm.estilo)},[(_vm.icone)?_c('v-icon',{attrs:{"small":""}},[_vm._v(_vm._s(_vm.cores.icone))]):_vm._e(),_vm._v(_vm._s(_vm.area)+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }